import { createMuiTheme } from '@material-ui/core';
import { ruRU } from '@material-ui/core/locale';

const deaultFontFamily = [
    'Roboto',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
].join(',');

// @ts-ignore
export const theme = createMuiTheme(
    {
        typography: {
            fontFamily: deaultFontFamily,
            button: {
                textTransform: 'none',
                textDecoration: 'none',
            },
            h1: {
                fontSize: '38px',
            },
            h2: {
                fontSize: '30px',
            },
            h3: {
                fontSize: '24px',
            },
            h4: {
                fontSize: '20px',
            },
            h5: {
                fontSize: '16px',
            },
        },
        overrides: {
            // MuiCssBaseline: {
            //     '@global': {
            //         fontFamily: deaultFontFamily,
            //         color: '#0a0e47',
            //         fontSize: '18px',
            //         backgroundColor: grey.A100,
            //     },
            // },
            MuiButton: {
                label: {},
                root: {
                    height: '40px',
                    padding: '0 30px',
                },
            },
            // MuiInputBase: {
            //   root: {
            //     height: '44px',
            //   },
            // },
            // MuiTextField: {
            //   root: {
            //     height: '44px',
            //   },
            // },
        },
        palette: {
            primary: {
                light: '#2667E5',
                main: '#0043C4',
                dark: '#002f87',
            },
            secondary: {
                light: '#FED201',
                main: '#FFA230',
                dark: '#F98500',
            },
        },
    },
    ruRU
);
